<template>
    <div class="background-img">

        <!--Header-->
        <v-toolbar style="background-color: black;border-top: 1px solid darkgray">

            <router-link class="button" to="/">
                <span class="font-highlight-small" style="color: white">หน้าแรก</span>
            </router-link>

            <v-spacer></v-spacer>

            <a class="button" href="download/Sonydays2019-phase2.pdf" target="_blank">  <!-- Catalog download -->
                <span class="font-highlight-small" style="color: white">Catalog</span>
                <img :src="menu.download" style="margin-top: 5px;">
            </a>
            <span style="border-right: 1px solid darkgray; padding: 15px 0;"></span>
            <a class="button" href="javascript:fbshare();">
                <img :src="menu.facebook_white" style="padding: 0 10px;">
                <span class="font-highlight-small" style="color: white">Share</span>
            </a>

        </v-toolbar>

        <!-- End Header -->

        <!-- Top banner -->
        <TopBanner></TopBanner>


        <v-layout>
            <v-flex xs12 sm6 offset-sm3>

                <!-- Category -->
                <SonyCategory></SonyCategory>


                <div class="select-section">
                    <b-form-select class="form-select" v-model="selected" onchange="jumpTo(value)"
                                   :options="options"></b-form-select>
                </div>

            </v-flex>
        </v-layout>


        <v-container fluid style="padding: 0 40px;" id="camera-1">

            <v-layout row justify-space-between>
                <v-flex xs12>
                    <div class="text-xs-center font-highlight">SONY Camera</div>
                    <div class="text-xs-center font-highlight-small">ตอบรับทุกไอเดียเพื่อ Vlogger ตัวจริง</div>
                </v-flex>
            </v-layout>

        </v-container>

        <v-container fluid class="sliding">

            <v-layout row justify-space-between>
                <v-flex xs12>
                    <slick ref="slick" :options="slickOptions" @afterChange="cameraAfterChange">

                        <div v-for="(product, index) in cameraList" :key="index" class="slideSpace">
                            <a :href="product.link" target="_blank">
                                <v-img class="product" :src="product.image"></v-img>
                            </a>
                        </div>

                    </slick>
                </v-flex>
            </v-layout>

        </v-container>

        <v-layout>
            <v-flex xs12 sm6 offset-sm3>

                <v-layout>
                    <v-flex style="text-align: right; padding-right: 5px">
                        <v-btn small style="background-color: #2A3186;color: white;border-radius: 6px"
                               :href="cameraLink" target="_blank">
                            อ่านเพิ่มเติม
                            <v-icon>chevron_right</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>

                <br>

            </v-flex>
        </v-layout>

        <div style="background-color: #5FC2BD">

                <img class="banner" :src="menu.banner6">

            <br>


            <div style="text-align: center">
                <v-container fluid style="padding: 0 40px;margin-top: 20px" id="camera-2">
                    <v-layout row justify-space-between>
                        <v-flex xs12>
                            <img :src="menu.specialdeal">
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>


            <v-container fluid class="sliding">

                <v-layout row justify-space-between>
                    <v-flex xs12>
                        <slick ref="slick" :options="slickOptions" @afterChange="cameraAfterChangeTwo">

                            <div v-for="(product, index) in cameraListTwo" :key="index" class="slideSpace">
                                <a :href="product.link" target="_blank">
                                    <v-img class="product" :src="product.image"></v-img>
                                </a>
                            </div>

                        </slick>
                    </v-flex>
                </v-layout>

            </v-container>

            <v-layout>
                <v-flex xs12 sm6 offset-sm3>

                    <v-layout>
                        <v-flex style="text-align: right; padding-right: 5px">
                            <v-btn small style="background-color: #2A3186;color: white;border-radius: 6px"
                                   :href="cameraLinkTwo" target="_blank">
                                อ่านเพิ่มเติม
                                <v-icon>chevron_right</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>

                    <br>

                </v-flex>
            </v-layout>

            <!--        <div class="banner-BG">-->
            <!--            <a href="https://www.sony.co.th/th/electronics/sound-bars/ht-x9000f?cid=ht-x9000f:dsp:ms:sonydays2019" target="_blank">-->
            <!--                <img class="banner" :src="menu.banner3">-->
            <!--            </a>-->
            <!--        </div>-->

            <!--        <v-layout>-->
            <!--            <v-flex xs12 sm6 offset-sm3>-->

            <!--                <v-container fluid class="sliding3" id="camera-3">-->

            <!--                    <v-layout row justify-space-between>-->
            <!--                        <v-flex xs12>-->
            <!--                            <div class="text-xs-left font-highlight" style="margin-left: 20px;">-->
            <!--                                SONY ANDROID TV-->
            <!--                                <br/><span class="font-highlight-small">เพลิดเพลินกับภาพยนต์ และแอพพลิเคชั่นความบันเทิงทุกรูปแบบ</span>-->
            <!--                            </div>-->
            <!--                        </v-flex>-->
            <!--                    </v-layout>-->

            <!--                    <v-layout row justify-space-between>-->
            <!--                        <v-flex xs12>-->
            <!--                            <slick ref="slick" :options="slickOptions2" @afterChange="cameraAfterChangeThree">-->

            <!--                                <div v-for="(product, index) in cameraListThree" :key="index" class="slideSpace">-->
            <!--                                    <a :href="product.link" target="_blank">-->
            <!--                                        <v-img class="product2" :src="product.image"></v-img>-->
            <!--                                    </a>-->
            <!--                                </div>-->

            <!--                            </slick>-->
            <!--                        </v-flex>-->
            <!--                    </v-layout>-->

            <!--                </v-container>-->


            <!--                <v-layout>-->
            <!--                    <v-flex style="text-align: right; padding-right: 5px">-->
            <!--                        <v-btn small style="background-color: #2A3186;color: white;border-radius: 6px"-->
            <!--                               :href="cameraLinkThree" target="_blank">-->
            <!--                            อ่านเพิ่มเติม-->
            <!--                            <v-icon>chevron_right</v-icon>-->
            <!--                        </v-btn>-->
            <!--                    </v-flex>-->
            <!--                </v-layout>-->


            <!-- back to top-->
            <v-btn id="btt" fab dark small
                   style="background: linear-gradient(135.9deg, #007581 0%, #2A3186 101.61%)"
                   href="javascript:backtotop();">
                <v-icon dark>arrow_drop_up</v-icon>
            </v-btn>

            <!--            </v-flex>-->
            <!--        </v-layout>-->

            <!--        <img class="banner" :src="menu.banner4">-->

        </div>

        <!-- Footer -->

        <!-- End Footer -->

    </div>
</template>
<style>
    .container.sliding.fluid,
    .container.sliding3.fluid,
    .container.sliding2.fluid {
        width: 100%;
    }

    .select-section {
        margin-top: 2px;
        width: 100%;
        text-align: center;
    }

    @media (min-width: 1080px)
    and (min-width: 1024px)
    and (min-width: 768px) {

        .select-section {
            margin-top: 2px;
            margin-left: 12px;
            width: 100%;
            text-align: left;
        }

    }

    .banner {
        width: 100%;
    }

    .form-select {
        width: 248px;
        height: 36px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        border: 1px solid #448EB7;
        box-sizing: border-box;
        border-radius: 80px;
    }

    .sliding3 {
        margin-top: 20px;
        margin-bottom: -15px;
        background-repeat: no-repeat;
        background-size: 100% auto;
        width: 100%;
        /*background-image: url('../assets/BG_set1.jpg');*/
    }

    .sliding2 {
        margin-top: 15px;
        margin-bottom: -15px;
        background-repeat: no-repeat;
        background-size: 100% auto;
        width: 100%;
        /*background-image: url('../assets/BG_set3.png');*/
    }

    .sliding {
        padding: 0 40px;
        margin-top: 15px;
        background-repeat: no-repeat;
        background-size: 100% auto;
        /*background-image: url('../assets/BG_set3.png');*/
        height: 370px;
    }

    .font-highlight {
        margin-top: 20px;
        font-size: 20px;
        font-weight: bold;
    }

    .font-highlight-small {
        font-size: 14px;
        font-weight: 600;
    }

    .product {
        margin: 50px 15px;
        width: 14em;
        height: 12em;
        top: 22px;
        left: 9px;
    }

    /* Desktop */
    @media (min-width: 1080px)
    and (min-width: 1024px)
    and (min-width: 768px) {
        .product {
            margin: 110px 50px;
            width: 30em;
            height: 25em;
            top: 22px;
            left: 9px;
        }

        .sliding {
            padding: 0 90px;
            margin-top: 15px;
            background-repeat: no-repeat;
            background-size: 100% auto;
            height: 730px;
        }
    }

    .product2 {
        margin-left: auto;
        margin-right: auto;

    }

    .layout-footer {
        padding: 38px;
        background-color: #252525;
    }

    .icon-social {
        margin-right: 13px;
    }

    .v-card.v-sheet.theme--dark {
        background-color: transparent;
    }

    .v-expansion-panel {
        box-shadow: none;
        -webkit-box-shadow: none;
    }

    .theme--dark.v-expansion-panel .v-expansion-panel__container {
        border-top: 2px solid rgba(255, 255, 255, 0.12);
        background-color: transparent;
        text-shadow: none;
    }

    .dl-info {
        font-size: 30px !important;
        color: #2A3186 !important;
        mix-blend-mode: normal;
    }

    .pagination-paddles {
        -webkit-transition: .2s ease-out;
        transition: .2s ease-out;
        position: absolute;
        width: 3em;
        height: 4.75em;
        display: block;
        margin-top: -2.375em;
        padding: 0;
        border: none;
        background-color: #212530;
        background-color: rgba(33, 37, 48, 0.4);
        border-radius: .1875em;
        cursor: pointer;
        opacity: 0;
        z-index: 1000;
    }

    .prevarrow {
        display: inline;
        position: absolute;
        top: 50%;
        z-index: 1000;
        font-size: 40px;
        color: #555555;
    }

    .nextarrow {
        display: inline;
        position: absolute;
        top: 50%;
        right: 0;
        z-index: 1000;
        font-size: 40px;
        color: #555555;
    }

    .button:link, .button:visited {
        color: black;
    }

    #btt {
        position: fixed;
        bottom: 10px;
        right: 10px;
        display: inline-block;
        background: #E8E8E8;
        z-index: 1000;
    }

    #btt:hover {
        cursor: pointer;
    }

    .background-img {
        background-image: url('../assets/BG_set1.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-attachment: fixed;
    }

    .banner-BG {
        background-image: url("../assets/banner/bannerBG.png");
    }


</style>

<script>
    import Slick from 'vue-slick';
    import SonyCategory from '../components/Category';
    import TopBanner from '../components/Topbanner';

    export default {
        components: {Slick, SonyCategory, TopBanner},
        name: "Camera",
        data() {
            return {
                slickOptions: {
                    centerMode: true,
                    infinite: true,
                    slidesToScroll: 1,
                    variableWidth: true,
                    prevArrow: '<a href="#" class="pagination-paddle outset pagination-prev on prevarrow" role="button" aria-label="Previous">\n' +
                        '                            <i class="fi fonticon-10-chevron-reverse"></i>\n' +
                        '                            </a>',
                    nextArrow: '<a href="#" class="pagination-paddle outset pagination-next on nextarrow" role="button" aria-label="Next">\n' +
                        '                            <i class="fi fonticon-10-chevron"></i>\n' +
                        '                            </a>',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: true,
                                centerMode: true,
                                infinite: true,
                                slidesToShow: 1,
                                prevArrow: '<a href="#" class="pagination-paddle outset pagination-prev on prevarrow" role="button" aria-label="Previous">\n' +
                                    '                            <i class="fi fonticon-10-chevron-reverse"></i>\n' +
                                    '                            </a>',
                                nextArrow: '<a href="#" class="pagination-paddle outset pagination-next on nextarrow" role="button" aria-label="Next">\n' +
                                    '                            <i class="fi fonticon-10-chevron"></i>\n' +
                                    '                            </a>',
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                arrows: true,
                                centerMode: true,
                                infinite: true,
                                slidesToShow: 1,
                                prevArrow: '<a href="#" class="pagination-paddle outset pagination-prev on prevarrow" role="button" aria-label="Previous">\n' +
                                    '                            <i class="fi fonticon-10-chevron-reverse"></i>\n' +
                                    '                            </a>',
                                nextArrow: '<a href="#" class="pagination-paddle outset pagination-next on nextarrow" role="button" aria-label="Next">\n' +
                                    '                            <i class="fi fonticon-10-chevron"></i>\n' +
                                    '                            </a>',
                            }
                        }
                    ],

                },
                slickOptions2: {
                    dots: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    arrows: true,
                    prevArrow: '<a href="#" class="pagination-paddle outset pagination-prev on prevarrow" role="button" aria-label="Previous">\n' +
                        '                            <i class="fi fonticon-10-chevron-reverse"></i>\n' +
                        '                            </a>',
                    nextArrow: '<a href="#" class="pagination-paddle outset pagination-next on nextarrow" role="button" aria-label="Next">\n' +
                        '                            <i class="fi fonticon-10-chevron"></i>\n' +
                        '                            </a>',
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                dots: true,
                                infinite: true,
                                speed: 300,
                                slidesToShow: 1,
                                arrows: true,
                                prevArrow: '<a href="#" class="pagination-paddle outset pagination-prev on prevarrow" role="button" aria-label="Previous">\n' +
                                    '                            <i class="fi fonticon-10-chevron-reverse"></i>\n' +
                                    '                            </a>',
                                nextArrow: '<a href="#" class="pagination-paddle outset pagination-next on nextarrow" role="button" aria-label="Next">\n' +
                                    '                            <i class="fi fonticon-10-chevron"></i>\n' +
                                    '                            </a>',
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                dots: true,
                                infinite: true,
                                speed: 300,
                                slidesToShow: 1,
                                arrows: true,
                                prevArrow: '<a href="#" class="pagination-paddle outset pagination-prev on prevarrow" role="button" aria-label="Previous">\n' +
                                    '                            <i class="fi fonticon-10-chevron-reverse"></i>\n' +
                                    '                            </a>',
                                nextArrow: '<a href="#" class="pagination-paddle outset pagination-next on nextarrow" role="button" aria-label="Next">\n' +
                                    '                            <i class="fi fonticon-10-chevron"></i>\n' +
                                    '                            </a>',
                            }
                        }
                    ],

                },

                // รูปและไอค็อนส่วนของหน้าเว็บหลัก
                menu: {
                    sony: require('../assets/logo.png'),
                    facebook: require('../assets/Group.png'),
                    home: require('../assets/home.png'),
                    banner2: null,
                    banner3: null,
                    banner4: null,
                    banner5: require('../assets/banner/banner2_sound.png'),
                    banner6: null,
                    specialdeal: require('../assets/banner/deal.png'),
                    facebook_white: require('../assets/input/facebook-ico.png'),
                    instagram_white: require('../assets/input/instagram-ico.png'),
                    youtube_white: require('../assets/input/youtube-ico.png'),
                    download: require('../assets/input/dl.png'),

                },
                selected: 'none',
                options: [
                    {value: 'none', text: 'เลือกรุ่นที่ต้องการ'},
                    {value: 'camera-1', text: 'SONY Camera'},
                    {value: 'camera-2', text: 'Grip'},
                    // {value: 'camera-3', text: 'SONY ANDROID TV'},

                ],
                // Slide 1
                cameraList: [
                    {
                        link: 'https://www.sony.co.th/th/electronics/interchangeable-lens-cameras/ilce-6400?cid=ilce-6400:dsp:ms:sonydays2019',
                        image: require('@/assets/img/camera/SONY-Camera/Camera1.png')
                    },
                    {
                        link: 'https://www.sony.co.th/th/electronics/cyber-shot-compact-cameras/dsc-rx0m2?cid=dsc-rx0m2:dsp:ms:sonydays2019',
                        image: require('@/assets/img/camera/SONY-Camera/Camera2.png')
                    },
                    {
                        link: 'https://www.sony.co.th/th/electronics/cyber-shot-compact-cameras/dsc-rx100m6?cid=dsc-rx100m6:dsp:ms:sonydays2019',
                        image: require('@/assets/img/camera/SONY-Camera/Camera3.png')
                    },
                    {
                        link: 'https://www.sony.co.th/th/electronics/handycam-camcorders/fdr-ax33?cid=fdr-ax33:dsp:ms:sonydays2019',
                        image: require('@/assets/img/camera/SONY-Camera/Camera4.png')
                    },
                    {
                        link: 'https://www.sony.co.th/th/electronics/actioncam/fdr-x3000-body-kit?cid=fdr-x3000-body-kit:dsp:ms:sonydays2019',
                        image: require('@/assets/img/camera/SONY-Camera/Camera5.png')
                    }

                ],
                // Slide 2
                cameraListTwo: [
                    {
                        link: 'https://www.sony.co.th/th/electronics/handycam-camcorders-tripods-remotes/gp-vpt1?cid=gp-vpt1:dsp:ms:sonydays2019',
                        image: require('@/assets/img/camera/SONY-Camera/Camera6.png')
                    },
                    {
                        link: 'https://www.sony.co.th/th/electronics/cyber-shot-compact-cameras-tripods-remotes/vct-sgr1?cid=ilce-7m2-body-kit:dsp:ms:sonydays2019',
                        image: require('@/assets/img/camera/SONY-Camera/Camera7.png')
                    },
                    {
                        link: 'https://www.sony.co.th/th/electronics/actioncam-mounting-accessories/vct-stg1?cid=ilce-7m2-body-kit:dsp:ms:sonydays2019',
                        image: require('@/assets/img/camera/SONY-Camera/Camera8.png')
                    }

                ],
                // Slide 3
                cameraListThree: [
                    {
                        link: 'https://www.sony.co.th/th/electronics/televisions/x9000f-series?cid=x9000f-series:dsp:ms:sonydays2019',
                        image: require('@/assets/img/tv/Android-TV/AndroidTV_X9000F.png')
                    },
                    {
                        link: 'https://www.sony.co.th/th/electronics/televisions/x8500f-x8577f-series?cid=x8500f-series:dsp:ms:sonydays2019',
                        image: require('@/assets/img/tv/Android-TV/AndroidTV_X8500F.png')
                    }
                ],

                cameraLink: null,
                cameraLinkTwo: null,
                cameraLinkThree: null,


            }
        },
        created() {
            this.cameraLink = this.cameraList[0].link;
            this.cameraLinkTwo = this.cameraListTwo[0].link;
            this.cameraLinkThree = this.cameraListThree[0].link;

            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },

        // All slick methods can be used too, example here
        methods: {
            next() {
                this.$refs.slick.next();
            },

            prev() {
                this.$refs.slick.prev();
            },

            reInit() {
                // Helpful if you have to deal with v-for to update dynamic lists
                this.$nextTick(() => {
                    this.$refs.slick.reSlick();
                });
            },

            // Events listeners
            cameraAfterChange(event, slick, currentSlide) {
                // eslint-disable-next-line
                this.cameraLink = this.cameraList[currentSlide].link
            },

            cameraAfterChangeTwo(event, slick, currentSlide) {
                this.cameraLinkTwo = this.cameraListTwo[currentSlide].link
            },

            cameraAfterChangeThree(event, slick, currentSlide) {
                this.cameraLinkThree = this.cameraListThree[currentSlide].link
            },

            handleResize() {
                let width = window.innerWidth;
                // size mobile
                if (width < 576) {
                    this.size = 'mobile';
                    this.menu.banner6 = require('../assets/banner/mbanner2_camera.png');

                } else {
                    this.size = 'desktop';
                    this.menu.banner6 = require('../assets/banner/banner2_camera.png');

                }
            }

            // handleBeforeChange(event, slick, currentSlide, nextSlide) {
            //     console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
            // },
            // handleBreakpoint(event, slick, breakpoint) {
            //     console.log('handleBreakpoint', event, slick, breakpoint);
            // },
            // handleDestroy(event, slick) {
            //     console.log('handleDestroy', event, slick);
            // },
            // handleEdge(event, slick, direction) {
            //     console.log('handleEdge', event, slick, direction);
            // },
            // handleInit(event, slick) {
            //     console.log('handleInit', event, slick);
            // },
            // handleReInit(event, slick) {
            //     console.log('handleReInit', event, slick);
            // },
            // handleSetPosition(event, slick) {
            //     console.log('handleSetPosition', event, slick);
            // },
            // handleSwipe(event, slick, direction) {
            //     console.log('handleSwipe', event, slick, direction);
            // },
            // handleLazyLoaded(event, slick, image, imageSource) {
            //     console.log('handleLazyLoaded', event, slick, image, imageSource);
            // },
            // handleLazeLoadError(event, slick, image, imageSource) {
            //     console.log('handleLazeLoadError', event, slick, image, imageSource);
            // },
        },
    }


</script>
